import { fromJS } from 'immutable';

export const SET_SELECTED_HOTELS = 'hotels/SET_SELECTED_HOTELS';

export const setSelectedHotels = (hotels) => ({
  type: SET_SELECTED_HOTELS,
  payload: hotels,
});

const initialState = fromJS({
  selectedHotels: [],
});

// eslint-disable-next-line default-param-last -- ducks
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_HOTELS:
      return state.set('selectedHotels', action.payload);
    default:
      return state;
  }
}
